import React from 'react';
import {footerContent, footerLinks} from '../../constants/footer.js'
import FordLogo from '../../images/footer-logo.png'
import FooterSocialIcons from '../FooterSocialIcons'
import './MobileFooter.css'

const MobileFooter = (props) => {
  return (
    <div className="mobile-footer-container">
  <div className="knotch-container" >
    <div className="knotch_placeholder" data-width="100%" data-height="250px"></div>
  </div>
      <div id="ccpa-banner">
        <h2>
          California Residents
        </h2>
        <p>
          Exercise your rights under the California Consumer Privacy Act&nbsp;
          <a href="https://www.ford.com/help/privacy/ccpa/?ccpatype=deletemypi" style={{display: 'inline'}}>here</a>
        </p>
        <a className="ccpa-button" href="https://www.ford.com/help/privacy/ccpa/?ccpatype=donotsellmypi">
          Do Not  Sell My Personal Information
        </a>
      </div>
      <div className="mobile-footer-content">
        {footerContent.map(section => {
          return (
            <div key={section.heading} style={{borderTop: '1px solid #e5e5e5', padding: '0px 30px', display: 'flex', flexDirection: 'column', alignItems: 'flex-start'}}>
              <div className="blue-title">{section.heading}</div>
              {section.links.map(sectionLink => {
                return (
                  <a key={sectionLink.heading} className={'grey-link link-with-border'} href={sectionLink.href}  onClick={props.trackClick('footer-link-click', sectionLink.heading)} target="_blank" rel="noopener noreferrer">{sectionLink.heading}</a>
                )
              })}
            </div>
          )
        })}
      </div>
      <div className="mobile-footer-white-section">
        <FooterSocialIcons />
        {footerLinks.map(footerLink => {
          return footerLink.heading.indexOf('Cookie') > -1 ? (
            <a key={footerLink.heading} className={'grey-link'} href={footerLink.href} rel="noopener noreferrer" onClick={props.trackClick('footer-link-click', footerLink.heading)}>{footerLink.heading}</a>
          ) :
          (
            <a key={footerLink.heading} className={'grey-link'} href={footerLink.href} target="_blank" rel="noopener noreferrer" onClick={props.trackClick('footer-link-click', footerLink.heading)}>{footerLink.heading}</a>
          )
        })}
        <a href="https://corporate.ford.com/homepage.html?intcmp=BFA-Microsite-FMC-CTA-20200515">
          <img className="mobile-footer-ford-logo" src={FordLogo} alt="Ford logo"/>
        </a>
      </div>
    </div>
    )
      }


      export default MobileFooter
